import { Action } from '@ngrx/store';
import { BpmnDeploymentIdentifier } from '@ispm-shared/modules/bpmn';
import { Progression } from '@ispm-shared/modules/common';

export enum BpmnProcessActionTypes {
  START_EXECUTION = '[Bpmn Process] Start Execution',
  RESTART_EXECUTION = '[Bpmn Process] Restart Execution',
  UPDATE_PROCESS_INSTANCE = '[Bpmn Process] Update Process Instance',
  FETCH_EXECUTION_HISTORY = '[Bpmn Process] Fetch Execution History',
  INIT_EXECUTION = '[Bpmn Process] Init execution',
  LOAD_EXISTING_EXECUTION = '[Bpmn Process] Load Existing execution',
  UPDATE_PROCESS_EXECUTION_MODE = '[Bpmn Process] Update Process Execution Mode',
  RUN_WITH_PROGRESSION = '[Bpmn Process] Run with progression',
}


export class StartExecutionAction implements Action {
  readonly type = BpmnProcessActionTypes.START_EXECUTION;
  constructor(public payload: { bpmnProcessId: string, patientData: any}) { }
}

export class RestartExecutionAction implements Action {
  readonly type = BpmnProcessActionTypes.RESTART_EXECUTION;
}

export class UpdateProcessInstanceAction implements Action {
  readonly type = BpmnProcessActionTypes.UPDATE_PROCESS_INSTANCE;
  constructor(public payload: { processInstanceId: string }) { }
}

export class FetchExecutionHistoryAction implements Action {
  readonly type = BpmnProcessActionTypes.FETCH_EXECUTION_HISTORY;
  constructor(public payload: { processInstanceId: string}) { }
}

export class InitExecutionAction implements Action {
  readonly type = BpmnProcessActionTypes.INIT_EXECUTION;
  constructor(public payload: { patientData: any, bpmnDeplymentIdentifier: BpmnDeploymentIdentifier}) { }
}

export class LoadExsitingExecutionAction implements Action {
  readonly type = BpmnProcessActionTypes.LOAD_EXISTING_EXECUTION;
  constructor(public payload: { bpmnDeploymentIdentifier: BpmnDeploymentIdentifier, processInstanceId: string}) { }
}

export class RunWithProgressionAction implements Action {
  readonly type = BpmnProcessActionTypes.RUN_WITH_PROGRESSION;
  constructor(public payload: { progression: Progression}) { }
}

export type BpmnProcessActions =
  StartExecutionAction |
  UpdateProcessInstanceAction |
  FetchExecutionHistoryAction |
  InitExecutionAction |
  LoadExsitingExecutionAction |
  RunWithProgressionAction;
